import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Dialog, Toast } from "react-vant"
import finger from "@/assets/images/finger_up.png"
import "./index.less"
import { HighlightPercentages_1 } from "../../utils"
import ButtonComp from "../common/ButtonComp"
import { putGuideTypeList, getGuideTypeList } from "@/api/account.js"
import { useDispatch } from "react-redux"
import { changeGuideTypeList } from "../../store/module/progress"

const AgentsGuide = () => {
  const [visible, setVisible] = useState(true)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const navList = [
    {
      name: t("ai.hot"),
      id: 1,
    },
    {
      name: t("ai.new"),
      id: 2,
    },
    {
      name: t("ai.mine"),
      id: 3,
    },
  ]

  const agentsGuideText = [
    {
      text: t("agentsGuideText.text"),
      id: 1,
    },
    {
      text: t("agentsGuideText.text_1"),
      id: 2,
    },
    {
      text: t("agentsGuideText.text_2"),
      id: 3,
    },
  ]
  const [add, setAdd] = useState(0)

  const getGuideType = async () => {
    const { code, data } = await getGuideTypeList()
    if (code == 0) {
      let obj: any = {}
      if (Array.isArray(data.tasks)) {
        data.tasks.forEach((el: any) => {
          obj[el.code] = el.status
        });
        dispatch(changeGuideTypeList({ ...data, tasks: obj }))
      } else {
        dispatch(changeGuideTypeList(data))
      }
    }
  }

  return (
    <Dialog
      visible={visible}
      showConfirmButton={false}
      showCancelButton={false}
      closeOnClickOverlay={false}
      onClose={() => { setVisible(false) }}
      width={'100%'}
    >
      <div className="h-[100vh] w-[100%]" onClick={async () => {
        if (add < 2) {
          setAdd(add + 1)
        } else {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('avatarGuide')
          await getGuideType()
          toast.clear()
        }
      }}>
        {/* 第一步 */}
        {add == 0 && <div className="absolute top-[52px] left-4 ">
          <div className=" flex items-center">
            <div onClick={() => {
            }} className={`bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px] text-[#A6A6A6] h-[36px] flex justify-center overflow-auto items-center py-1 rounded-[10px]`}>
              <span className={`text-white flex items-center`}>
                {navList[0].name}&nbsp;
                425
              </span>
            </div>
            <div onClick={() => {
            }} className={`bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px] text-[#A6A6A6] h-[36px] flex justify-center overflow-auto items-center py-1 rounded-[10px]`}>
              <span className={`text-white flex items-center`}>
                {navList[1].name}
              </span>
            </div>
          </div>
          <div className=" triangle-up rounded-[10px] mt-[50px] w-[250px] relative p-[10px] bg-white">
            <img className=" w-[31px] h-11 absolute left-[40px] -top-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold">{t("agentsGuideText.welcome")}</p>
            <p className="mt-2.5 text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(agentsGuideText[0].text) }}></p>
          </div>
          <p className="text-[14px] text-[#fff] leading-[20px] font-semibold mt-1.5">{t("agentsGuideText.click_tip")}</p>
        </div>}

        {/* 第二步 */}
        {add == 1 && <div className="bottom-[130px] flex flex-col-reverse absolute z-10 left-[50%] translate-x-[-50%]">
          <ButtonComp children={
            <svg width="14px" className='mr-1' height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-135.000000, -667.000000)">
                  <g transform="translate(135.000000, 667.000000)">
                    <rect fill="#D8D8D8" opacity="0" x="0" y="0" width="14" height="14"></rect>
                    <g transform="translate(1.000000, 0.000000)" fill="#FFFFFF" fillRule="nonzero">
                      <path d="M11.9335355,7.62303152 L11.0266453,5.59439713 L11.0266453,5.31988638 C11.0254568,3.85342934 10.4113386,2.45837032 9.3408964,1.49046152 C8.12276503,0.38103467 6.50602008,-0.147343163 4.88913236,0.035554589 C2.34717244,0.304575111 0.306669451,2.27556225 0.0319350571,4.72145297 C-0.15629891,6.41924835 0.495917588,8.10094747 1.76836309,9.19872317 C2.27529829,9.62937567 2.49898336,10.3199999 2.34450511,10.9775528 L1.81104028,13.0583442 C1.72488752,13.2987665 1.7556188,13.5670899 1.89372732,13.7803075 C2.000878,13.9209047 2.16556174,14.0020957 2.33917047,13.9999589 L7.31906467,13.9999589 C7.59639231,14.0003362 7.83788283,13.8051416 7.90320867,13.5277576 L8.23128954,12.0179485 C8.28211602,11.8483879 8.43780214,11.7355526 8.61004958,11.7434378 L9.91970574,11.7434378 C10.2082993,11.7500547 10.4875162,11.6378176 10.6953548,11.4316494 C10.9031935,11.2254812 11.0224509,10.9424465 11.0266453,10.6453948 L11.0266453,8.72381959 L11.2080233,8.72381959 C11.4799989,8.72549105 11.7341786,8.58487244 11.8828563,8.35048498 C12.0185278,8.13253687 12.0376072,7.85867002 11.9335355,7.62303152 L11.9335355,7.62303152 Z M5.69092202,3.56928969 C5.33883837,3.90472536 4.82767773,3.99494456 4.3871142,3.7994101 C4.32704015,3.77427737 4.25980524,3.77427737 4.19973119,3.7994101 C4.14630909,3.81970504 4.10351569,3.8619847 4.08163265,3.91609087 C3.95731633,4.16911992 3.76843262,4.38255881 3.5352301,4.53352661 C3.43429621,4.60252243 3.37483945,4.7200084 3.37776539,4.84467533 L3.37776539,5.09262197 C3.347185,5.33487788 3.14667748,5.51615845 2.90930787,5.51615845 C2.67193826,5.51615845 2.47143074,5.33487788 2.44085036,5.09262197 L2.44085036,4.79119665 C2.434816,4.65901247 2.36668014,4.53811108 2.25819128,4.46708339 C1.88125228,4.2043136 1.71669764,3.71799943 1.85350698,3.2711055 C2.08129498,2.56592024 2.59990525,2.00016247 3.27068939,1.7250853 C3.9083176,1.45517584 4.62210884,1.44647884 5.2657673,1.70077681 C5.69407131,1.86283344 5.98223173,2.18694668 6.05309085,2.55643579 C6.11226624,2.93595319 5.97502002,3.31978071 5.69092202,3.56928969 L5.69092202,3.56928969 Z" id="形状"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          } title={t("ai.create")} callBack={() => {

          }}></ButtonComp>
          <div className=" triangle-down rounded-[10px] mb-[50px] w-[250px] relative p-[10px] bg-white">
            <img className=" w-[31px] finger_down h-11 absolute left-[50%] rotate-180 -translate-x-[50%] -bottom-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(agentsGuideText[1].text) }}></p>
          </div>
        </div>}

        {/* 第三步 */}
        {add == 2 && <div className="absolute top-[52px] left-4 ">
          <div className=" flex items-center">
            <div onClick={() => {
            }} className={`bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px] text-[#A6A6A6] opacity-0 h-[36px] flex justify-center overflow-auto items-center py-1 rounded-[10px]`}>
              <span className={`text-white flex items-center`}>
                {navList[0].name}&nbsp;
                425
              </span>
            </div>
            <div onClick={() => {
            }} className={`bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px] text-[#A6A6A6] opacity-0 h-[36px] flex justify-center overflow-auto items-center py-1 rounded-[10px]`}>
              <span className={`text-white flex items-center`}>
                {navList[1].name}
              </span>
            </div>
            <div onClick={() => {
            }} className={`bg-gradient-to-r from-[#00E49F] to-[#54ADFF] !w-[80px] text-[#A6A6A6] h-[36px] flex justify-center overflow-auto items-center py-1 rounded-[10px]`}>
              <span className={`text-white flex items-center`}>
                {navList[2].name}&nbsp;25
              </span>
            </div>
          </div>
          <div className=" triangle-up New_1 rounded-[10px] mt-[50px] w-[250px] relative p-[10px] bg-white">
            <img className=" w-[31px] h-11 absolute left-[183px] -top-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(agentsGuideText[2].text) }}></p>
          </div>
        </div>}
        <p onClick={async () => {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('avatarGuide')
          await getGuideType()

          toast.clear()
        }} className=" absolute underline bottom-10 left-[50%] translate-x-[-50%] text-[14px] text-[#fff] leading-[18px] font-semibold">{t("skip_the_tutorial")}</p>

      </div>
    </Dialog>
  )
}
export default AgentsGuide